import { FormattedMessage } from "react-intl";

import { useGetQuickRequestDetails } from "api/queries/quick-request/useGetQuickRequestDetails";
import Drawer from "components/v2/Drawer/Drawer";
import DrawerHeader from "components/v2/Drawer/components/DrawerHeader/DrawerHeader";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import Card from "components/molecules/Card/Card";
import CardNew from "components/molecules/Card/CardNew";
import QuickOrganisationalDetails from "pages/shipper/ShipmentDetails/components/QuickOrganisationalDetails";
import QuickSchedule from "pages/shipper/ShipmentDetails/components/QuickSchedule";
import QuoteAttachments from "pages/shipper/ShipmentDetails/components/QuoteAttachments";
import QuickService from "pages/shipper/ShipmentDetails/components/QuickService";
import QuickPackingList from "pages/shipper/ShipmentDetails/components/QuickPackingList";
import "./QuickRequestDrawer.scss";

function QuickRequestDrawer({ isOpen, handleClose, quickRequestReference }: any) {
  if (!quickRequestReference) return null;

  const { data, isInitialLoading }: any = useGetQuickRequestDetails(quickRequestReference, {
    enabled: true,
  });

  return (
    <Drawer size="md" isOpen={isOpen} onClose={handleClose}>
      <DrawerHeader title={quickRequestReference} />
      {isInitialLoading && <LoadingSkeleton rows={3} />}
      {!isInitialLoading && (
        <div className="shipment-details-container">
          <div className="column-content">
            <QuickOrganisationalDetails data={data} loadingData={false} isDrawer />
            <div className="drawer-separator" />
            <QuickSchedule data={data} loadingData={false} isDrawer />
            <div className="drawer-separator" />
            <CardNew
              className={`${data?.organization?.additional_comments ? "" : "d-none"}`}
              isLoading={false}
              title={
                <FormattedMessage id="quote-request-detail.additionalInformation" defaultMessage="Additional information" />
              }
            >
              <CardNew.Body>
                <Card.Text>{data?.organization?.additional_comments}</Card.Text>
              </CardNew.Body>
            </CardNew>
            <QuickService data={data} loadingData={false} isDrawer />
            <div className="drawer-separator" />
            <QuickPackingList data={data} isDrawer loadingData={false} />
            <div className="drawer-separator" />
            <QuoteAttachments data={data} isQuickRequest hideDownloadButton />
          </div>
        </div>
      )}
    </Drawer>
  );
}

export default QuickRequestDrawer;
